var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.visited
    ? _c(
        "div",
        [
          _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              staticClass: "app-main-inner adjust-window",
              attrs: {
                "close-on-click-modal": false,
                visible: _vm.innerVisible,
                title: _vm.title,
                width: "1000px",
                "before-close": _vm.cancel,
                "append-to-body": ""
              },
              on: {
                "update:visible": function($event) {
                  _vm.innerVisible = $event
                }
              }
            },
            [
              _c(
                "div",
                { staticClass: "app-main-inner-row" },
                [
                  _c(
                    "el-form",
                    {
                      attrs: {
                        "label-position": "left",
                        "label-width": "90px",
                        model: _vm.adjustCharge
                      }
                    },
                    [
                      _c(
                        "el-row",
                        { attrs: { gutter: 10 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("SeaExport.ChargeItem")
                                  }
                                },
                                [
                                  _c("cargo-advance-select", {
                                    attrs: {
                                      filterable: "",
                                      "method-params": _vm.getChargeItemFilter,
                                      "select-type":
                                        _vm.selectTypeNames
                                          .basic_data_ChargeItem,
                                      "default-value":
                                        Number(_vm.adjustCharge.chargeItemId) ||
                                        "",
                                      "options-width": "250px",
                                      "tag-value": "itemId",
                                      "tag-name":
                                        _vm.$store.getters.language === "zh"
                                          ? "zhName"
                                          : "enName",
                                      disabled: !_vm.isEditing,
                                      "static-options": _vm.chargeItemList
                                    },
                                    on: { parentCallBack: _vm.onChangeCompany }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("SeaExport.AuditDate")
                                  }
                                },
                                [
                                  _c("el-date-picker", {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      type: "date",
                                      "value-format": "yyyy-MM-dd",
                                      format: "yyyy-MM-dd",
                                      "default-value": _vm.defaultAuditDate
                                    },
                                    on: { change: _vm.auditDateChangeHandler },
                                    model: {
                                      value: _vm.adjustCharge.auditDate,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.adjustCharge,
                                          "auditDate",
                                          $$v
                                        )
                                      },
                                      expression: "adjustCharge.auditDate"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        { attrs: { gutter: 10 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("SeaExport.AccountObject")
                                  }
                                },
                                [
                                  _vm.isAr && _vm.arSettlementUnitOptional
                                    ? _c("cargo-advance-select", {
                                        key: "accountIdAr",
                                        attrs: {
                                          filterable: "",
                                          "method-params": { active: true },
                                          "select-type":
                                            _vm.selectTypeNames
                                              .basic_data_Company,
                                          "default-value":
                                            Number(
                                              _vm.adjustCharge.accountId
                                            ) || "",
                                          disabled: !_vm.isEditing,
                                          "options-width": "200px;",
                                          "auto-key": "auto_0",
                                          "tag-name": "chineseName",
                                          "static-options":
                                            _vm.companyFactorySigns
                                        },
                                        on: {
                                          parentCallBack:
                                            _vm.textAccountCode_changeHandler
                                        }
                                      })
                                    : _vm.isAr
                                    ? _c("cargo-advance-select", {
                                        key: "accountIdAr",
                                        attrs: {
                                          filterable: "",
                                          "method-params": { active: true },
                                          "select-type":
                                            _vm.selectTypeNames
                                              .basic_data_Company,
                                          "default-value":
                                            Number(
                                              _vm.adjustCharge.accountId
                                            ) || "",
                                          disabled: !_vm.isEditing,
                                          "options-width": "200px;",
                                          "auto-key": "auto_0",
                                          "data-filter-function":
                                            _vm.dataFilterFunction
                                        },
                                        on: {
                                          parentCallBack:
                                            _vm.textAccountCode_changeHandler
                                        }
                                      })
                                    : _c("cargo-advance-select", {
                                        key: "accountIdAp",
                                        attrs: {
                                          filterable: "",
                                          "method-params": { active: true },
                                          "select-type":
                                            _vm.selectTypeNames
                                              .basic_data_Company,
                                          "default-value":
                                            Number(
                                              _vm.adjustCharge.accountId
                                            ) || "",
                                          disabled: !_vm.isEditing,
                                          "options-width": "200px;",
                                          "auto-key": "auto_0",
                                          "data-filter-function":
                                            _vm.dataFilterFunction
                                        },
                                        on: {
                                          parentCallBack:
                                            _vm.textAccountCode_changeHandler
                                        }
                                      })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: !_vm.isAdvance,
                                      expression: "!isAdvance"
                                    }
                                  ],
                                  attrs: {
                                    label: _vm.$t("SeaExport.ContactPerson")
                                  }
                                },
                                [
                                  _c("cargo-advance-select", {
                                    attrs: {
                                      "select-type":
                                        _vm.selectTypeNames.static_data_Contact,
                                      "options-width": "160px;",
                                      filterable: "",
                                      cache: false,
                                      disabled: !_vm.isEditing,
                                      "default-value":
                                        _vm.adjustCharge.contactPerson || "",
                                      "static-options": _vm.contactArray
                                    },
                                    on: {
                                      parentCallBack: function(item) {
                                        return (_vm.adjustCharge.contactPerson =
                                          item.value)
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.needMakeInvoice,
                                      expression: "needMakeInvoice"
                                    }
                                  ],
                                  attrs: {
                                    label: _vm.$t("SeaExport.IsNeedInvoice")
                                  }
                                },
                                [
                                  _c("cargo-advance-select", {
                                    attrs: {
                                      filterable: "",
                                      clearable: false,
                                      fields: ["value"],
                                      "callback-params": { key: "needInvoice" },
                                      "callback-method-type": "value",
                                      "default-value":
                                        _vm.adjustCharge.needInvoice,
                                      cache: false,
                                      "tag-value": "code",
                                      "tag-name": "value",
                                      "options-width": "130px",
                                      disabled: !_vm.isEditing,
                                      "static-options": [
                                        {
                                          code: false,
                                          value: _vm.$t("SeaExport.No")
                                        },
                                        {
                                          code: true,
                                          value: _vm.$t("SeaExport.Yes")
                                        }
                                      ],
                                      "filter-tag-names": ["value"]
                                    },
                                    on: {
                                      parentCallBack: function(item) {
                                        return (_vm.adjustCharge.needInvoice =
                                          item.value)
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        { attrs: { gutter: 10 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "FinanceManage.charge_invoiceHeader"
                                    )
                                  }
                                },
                                [
                                  _c("cargo-advance-select", {
                                    attrs: {
                                      filterable: true,
                                      "filter-tag-names": ["invoiceTitle"],
                                      "filter-type": "global",
                                      "allow-create":
                                        !_vm.arSettlementUnitOptional ||
                                        !_vm.isAr,
                                      "default-value":
                                        _vm.adjustCharge.invoiceTitle,
                                      disabled: !_vm.isEditing,
                                      "options-width": "200px;",
                                      "tag-value": "invoiceTitle",
                                      "tag-name": "invoiceTitle",
                                      "static-options": _vm.invoiceTitleList
                                    },
                                    on: {
                                      parentCallBack:
                                        _vm.textInvoiceTitleChangeHandle
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "FinanceManage.charge_relatedContainerNo"
                                    )
                                  }
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      ref: "select",
                                      attrs: { disabled: !_vm.isEditing },
                                      on: {
                                        change: _vm.containerNoChangeHandle
                                      },
                                      model: {
                                        value:
                                          _vm.adjustCharge.relationContainerNo,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.adjustCharge,
                                            "relationContainerNo",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "adjustCharge.relationContainerNo"
                                      }
                                    },
                                    _vm._l(_vm.relatedContainerOption, function(
                                      item,
                                      index
                                    ) {
                                      return _c("el-option", {
                                        key: index,
                                        attrs: {
                                          label: item["containerNo"],
                                          value: item["containerNo"]
                                        }
                                      })
                                    }),
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "FinanceManage.charge_relatedBLNo"
                                    )
                                  }
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      ref: "select",
                                      attrs: { disabled: !_vm.isEditing },
                                      model: {
                                        value: _vm.adjustCharge.relatedMbl,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.adjustCharge,
                                            "relatedMbl",
                                            $$v
                                          )
                                        },
                                        expression: "adjustCharge.relatedMbl"
                                      }
                                    },
                                    _vm._l(_vm.blOption, function(group) {
                                      return _c(
                                        "el-option-group",
                                        {
                                          key: group.label,
                                          attrs: { label: group.label }
                                        },
                                        _vm._l(group.options, function(
                                          item,
                                          index
                                        ) {
                                          return _c("el-option", {
                                            key: index,
                                            attrs: {
                                              label: item["chargeRelatedBLNo"],
                                              value: item["chargeRelatedBLNo"]
                                            }
                                          })
                                        }),
                                        1
                                      )
                                    }),
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        { attrs: { gutter: 10 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: _vm.$t("SeaExport.Unit") } },
                                [
                                  _c("cargo-advance-select", {
                                    attrs: {
                                      "select-type":
                                        _vm.selectTypeNames
                                          .basic_data_ChargeUnit,
                                      filterable: "",
                                      clearable: false,
                                      "options-width": "100px",
                                      disabled: !_vm.isEditing,
                                      "default-value":
                                        _vm.adjustCharge.measure || ""
                                    },
                                    on: {
                                      parentCallBack:
                                        _vm.combMeasureChangeHandler
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("SeaExport.Quantity2")
                                  }
                                },
                                [
                                  _c("el-input-number", {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      max: 99999999999999,
                                      min: -99999999999999,
                                      precision: 3,
                                      controls: false,
                                      disabled: !_vm.isEditing
                                    },
                                    on: {
                                      change: _vm.txtQuantityChangeHandler
                                    },
                                    model: {
                                      value: _vm.adjustCharge.quantity,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.adjustCharge,
                                          "quantity",
                                          $$v
                                        )
                                      },
                                      expression: "adjustCharge.quantity"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: { label: _vm.$t("SeaExport.UnitRate") }
                                },
                                [
                                  _c("el-input-number", {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      max: 99999999999999,
                                      min: -99999999999999,
                                      precision: 3,
                                      controls: false,
                                      disabled: !_vm.isEditing
                                    },
                                    on: {
                                      change: _vm.txtUnitRateChangeHandler
                                    },
                                    model: {
                                      value: _vm.adjustCharge.unitRate,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.adjustCharge,
                                          "unitRate",
                                          $$v
                                        )
                                      },
                                      expression: "adjustCharge.unitRate"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: { label: _vm.$t("SeaExport.Oversea") }
                                },
                                [
                                  _c("cargo-advance-select", {
                                    attrs: {
                                      filterable: "",
                                      clearable: false,
                                      fields: ["value"],
                                      "callback-params": { key: "oversea" },
                                      "callback-method-type": "value",
                                      "default-value": _vm.adjustCharge.oversea,
                                      cache: false,
                                      "tag-value": "code",
                                      "tag-name": "value",
                                      disabled:
                                        !_vm.isEditing ||
                                        !_vm.canChangeOverseaOfCharge,
                                      "static-options": [
                                        {
                                          code: false,
                                          value: _vm.$t("SeaExport.internal")
                                        },
                                        {
                                          code: true,
                                          value: _vm.$t("SeaExport.overseas")
                                        }
                                      ],
                                      "filter-tag-names": ["value"],
                                      "options-width": "100px;"
                                    },
                                    on: {
                                      parentCallBack: function(item) {
                                        return (_vm.adjustCharge.oversea =
                                          item.value)
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c("el-row", { attrs: { gutter: 10 } }, [
                        _c(
                          "div",
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 6 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("SeaExport.Currency")
                                    }
                                  },
                                  [
                                    _c("cargo-advance-select", {
                                      attrs: {
                                        filterable: "",
                                        clearable: false,
                                        "select-type":
                                          _vm.selectTypeNames
                                            .basic_data_Currency,
                                        "default-value":
                                          _vm.adjustCharge.currency || "",
                                        "options-width": "100px",
                                        disabled: !_vm.isEditing
                                      },
                                      on: {
                                        parentCallBack:
                                          _vm.textCurrencyChangeHandler
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 6 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("SeaExport.ExchangeRate")
                                    }
                                  },
                                  [
                                    _c("num-input", {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        min: 0,
                                        max: 99999999999999,
                                        precision: 8,
                                        "truncated-precision":
                                          _vm.exchangeRatePrecision
                                      },
                                      model: {
                                        value: _vm.adjustCharge.exchangeRate,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.adjustCharge,
                                            "exchangeRate",
                                            $$v
                                          )
                                        },
                                        expression: "adjustCharge.exchangeRate"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 6 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("CargoMsg.Cargo_DateType")
                                    }
                                  },
                                  [
                                    _c("cargo-advance-select", {
                                      attrs: {
                                        disabled: !_vm.isEditing,
                                        cache: false,
                                        clearable: false,
                                        "tag-name": "name",
                                        "tag-value": "code",
                                        "static-options": _vm.dateTypeArray,
                                        "default-value": _vm.dateType
                                      },
                                      on: {
                                        parentCallBack: _vm.onDateTypeChange
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 6 } },
                              [
                                _vm.inputIncludingTaxUnitPrice
                                  ? _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "FinanceManage.charge_unitPriceIncludeTax"
                                          )
                                        }
                                      },
                                      [
                                        _c("cargo-advance-select", {
                                          attrs: {
                                            filterable: "",
                                            clearable: false,
                                            fields: ["value"],
                                            "callback-params": {
                                              key: "unitPriceIncludeTax"
                                            },
                                            "callback-method-type": "value",
                                            "default-value":
                                              _vm.adjustCharge
                                                .unitPriceIncludeTax,
                                            cache: false,
                                            "tag-value": "code",
                                            "tag-name": "value",
                                            "options-width": "130px",
                                            disabled: !_vm.isEditing,
                                            "static-options": [
                                              {
                                                code: true,
                                                value: _vm.$t("SeaExport.Yes")
                                              },
                                              {
                                                code: false,
                                                value: _vm.$t("SeaExport.No")
                                              }
                                            ],
                                            "filter-tag-names": ["value"]
                                          },
                                          on: {
                                            parentCallBack:
                                              _vm.unitPriceIncludeTaxChange
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]),
                      _c(
                        "el-row",
                        { attrs: { gutter: 10 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "SeaExport.IncludingTaxAmount"
                                    )
                                  }
                                },
                                [
                                  _c("el-input-number", {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      max: 99999999999999,
                                      min: -99999999999999,
                                      precision: 2,
                                      controls: false,
                                      disabled: !_vm.isEditing
                                    },
                                    on: { change: _vm.textAmountChangeHandler },
                                    model: {
                                      value: _vm.adjustCharge.amount,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.adjustCharge,
                                          "amount",
                                          $$v
                                        )
                                      },
                                      expression: "adjustCharge.amount"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: !_vm.isAdvance,
                                      expression: "!isAdvance"
                                    }
                                  ],
                                  attrs: {
                                    label: _vm.$t(
                                      "SeaExport.ExcludingTaxAmount"
                                    )
                                  }
                                },
                                [
                                  _c("el-input-number", {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      max: 99999999999999,
                                      min: -99999999999999,
                                      value: !_vm.needInvoiceNo
                                        ? _vm.adjustCharge.excludingTaxAmount
                                        : _vm.adjustCharge.amount,
                                      disabled: !_vm.isEditing,
                                      precision: 2,
                                      controls: false
                                    },
                                    on: {
                                      input: function(val) {
                                        _vm.adjustCharge.excludingTaxAmount = val
                                      },
                                      change:
                                        _vm.excludingTaxAmountChangeHandler
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: !_vm.isAdvance,
                                      expression: "!isAdvance"
                                    }
                                  ],
                                  attrs: {
                                    label: _vm.$t("SeaExport.BillAmount")
                                  }
                                },
                                [
                                  _c("el-input-number", {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      max: 99999999999999,
                                      min: -99999999999999,
                                      precision: 2,
                                      controls: false,
                                      disabled: true
                                    },
                                    model: {
                                      value: _vm.adjustCharge.taxAmount,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.adjustCharge,
                                          "taxAmount",
                                          $$v
                                        )
                                      },
                                      expression: "adjustCharge.taxAmount"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: !_vm.isAdvance,
                                      expression: "!isAdvance"
                                    }
                                  ],
                                  attrs: { label: _vm.$t("SeaExport.TaxRate") }
                                },
                                [
                                  _c("el-input-number", {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      max: 99999999999999,
                                      min: -99999999999999,
                                      value: isNaN(_vm.adjustCharge.taxRate)
                                        ? "0"
                                        : _vm.adjustCharge.taxRate,
                                      precision: 2,
                                      controls: false,
                                      disabled: !_vm.isEditing
                                    },
                                    on: {
                                      input: function(val) {
                                        _vm.adjustCharge.taxRate = val
                                      },
                                      change: _vm.txtRateChangeHandler
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.needInvoiceNo,
                                      expression: "needInvoiceNo"
                                    }
                                  ],
                                  attrs: {
                                    label: _vm.$t("SeaExport.InvoiceNo")
                                  }
                                },
                                [
                                  _c("el-input", {
                                    model: {
                                      value: _vm.adjustCharge.invoiceNo,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.adjustCharge,
                                          "invoiceNo",
                                          $$v
                                        )
                                      },
                                      expression: "adjustCharge.invoiceNo"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        !_vm.needInvoiceNo && _vm.openSapConfig,
                                      expression:
                                        "!needInvoiceNo && openSapConfig"
                                    }
                                  ],
                                  attrs: {
                                    label: _vm.$t(
                                      "Invoice.invoice_settleDepartmentPrefix"
                                    )
                                  }
                                },
                                [
                                  _c("cargo-advance-select", {
                                    attrs: {
                                      "select-type":
                                        _vm.selectTypeNames
                                          .basic_data_Department,
                                      "method-params": {
                                        officeUuid:
                                          _vm.$store.getters.currentOfficeUuid
                                      },
                                      "default-value":
                                        Number(
                                          _vm.adjustCharge
                                            .settleDepartmentPrefix
                                        ) || "",
                                      disabled: !_vm.isEditing,
                                      "options-width": "150px"
                                    },
                                    on: {
                                      parentCallBack: function(item) {
                                        return (_vm.adjustCharge.settleDepartmentPrefix =
                                          item.value)
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: { label: _vm.$t("SeaExport.Remarks") }
                                },
                                [
                                  _c("el-input", {
                                    attrs: { type: "textarea", rows: 5 },
                                    model: {
                                      value: _vm.adjustCharge.remarks,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.adjustCharge,
                                          "remarks",
                                          $$v
                                        )
                                      },
                                      expression: "adjustCharge.remarks"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                { attrs: { slot: "footer" }, slot: "footer" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "mini" },
                      on: { click: _vm.saveEvent }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.Confirm")))]
                  ),
                  _c(
                    "el-button",
                    { attrs: { size: "mini" }, on: { click: _vm.cancel } },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.Cancel")))]
                  )
                ],
                1
              )
            ]
          ),
          _vm.checkingSaveJobWindow.visible
            ? _c("checking-save-job-window", {
                attrs: {
                  visible: _vm.checkingSaveJobWindow.visible,
                  lob: _vm.checkingSaveJobWindow.lob,
                  "row-data": _vm.checkingSaveJobWindow.rowData,
                  "check-node": _vm.checkingSaveJobWindow.checkNode,
                  "call-back": _vm.checkingSaveJobWindow.callBack
                },
                on: {
                  "update:visible": function($event) {
                    return _vm.$set(
                      _vm.checkingSaveJobWindow,
                      "visible",
                      $event
                    )
                  }
                }
              })
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }